<template>
  <vs-prompt
    title="修改账户信息"
    @close="closeHandle"
    class="info-prompt"
    buttons-hidden

    :active.sync="dialogShow">
    <div
      class="con-exemple-prompt"
    >
      <div class="info">
        <div class="avatar-box">
          <el-upload
            class="avatar-uploader"
            action="''"
            :accept="$config.imgFormat"
            :show-file-list="false"
            :http-request="uploadImgUrlHandle"
            :before-upload="beforeAvatarUpload"
            v-loading="uploadLoading"
          >
            <img
              class="avatar-img"
              :src="imgUrl" alt="">
            <div

              class="add-btn pointer">
              <i class="el-icon-plus add-btn-el"></i>
            </div>
          </el-upload>
        </div>
        <div class="username">{{username}}</div>
      </div>
      <div class="pass-box">
        <span>密码</span>
        <el-button
          @click="editHandle"
        >修改</el-button>
      </div>
      <div class="btn-modules">

<!--        <el-button
          type="primary"
          @click="submitHandle"
          :loading="loading"
        >提交</el-button>-->
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { queryUserInfo } from "@/api/user";
import defaultAvatar from '../../assets/images/defaultAvatar.png';
import { limitImageSizeFormat } from "@/utils/common";
import { mapGetters } from 'vuex'
import {uploadAvatar} from "../../api/user";
export default {
  name: "editInfoDialog",
  data() {
    return {
      loading: false,
      dialogShow: false,
      uploadLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo','listRefresh']),
    username(){
      return this.userInfo.username;
    },
    imgUrl(){
      return this.userInfo.avatar || defaultAvatar;
    }
  },
  methods: {
    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    uploadImgUrlHandle(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.uploadLoading = true;
        this.$uploadFile(file).then((res) => {
          this.uploadLoading = false;
          console.log(res);
          this.submitHandle(res.data.url);
        })
      });

    },
    submitHandle(avatarUrl) {
      // 需要后台增加接口 todo
      uploadAvatar({
        avatar: avatarUrl
      }).then((res) => {
        if(res.code == 200){
          this.$emit('upload-avatar-success');
          this.$message.success('上传成功');
          this.getUserInfo();
        }
      })
    },
    getUserInfo(){
      queryUserInfo().then((data) => {
        this.$store.commit('setUserInfo', data.user);
      })
    },
    closeHandle(){
      this.dialogShow = false;
    },
    editHandle(){
      this.dialogShow = false;
      this.$emit('edit-pass');
    },
  },
}
</script>

<style lang="scss">
@import "../../assets/scss/variable";
.info-prompt {
  .vs-dialog {
    width: 614px;
    max-width: none;
    .vs-dialog-header .dialog-title {
      color: $themefontcolor;
    }
    .vs-dialog-text {
      padding: 0!important;
    }
    .info {
      text-align: center;
      padding: 20px 0;
      border-bottom: 1px solid #E0E4F2;
      .avatar-box {
        display: inline-block;
        position: relative;
        .add-btn {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background-color: $themeColor;
          position: absolute;
          bottom: 0;
          right: 6px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .add-btn-el {
            color: #ffffff;
            font-size: 16px;
          }
        }
      }
      .avatar-img {
        width: 72px;
        height: 72px;
        border-radius: 50%;
      }
      .username {
        color: #6E6B7B;
        padding-top: 20px;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .pass-box {
      height: 53px;
      border-bottom: 1px solid #E0E4F2;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .btn-modules {
      text-align: center;
      padding: 20px 0;
    }
  }
}

</style>
